"use strict";

/*global angular*/

(function () {
  "use strict";

  angular.module("pages").run(function ($rootScope, $location, ActionHistoriesService, ApiService) {
    var log = debug("pages:run");

    log("run pages");

    function transformToAssocArray(prmstr) {
      var params = {};
      var prmarr = prmstr.split("&");
      for (var i = 0; i < prmarr.length; i++) {
        var tmparr = prmarr[i].split("=");
        params[decodeURIComponent(tmparr[0])] = decodeURIComponent(tmparr.slice(1).join("="));
      }
      return params;
    }

    function getAllParams() {
      var params = {};

      // 1. Token sauvegardé avant le bootstrap Angular (nettoyage de l'URL avant que Angular cache appBase)
      var pendingToken = sessionStorage.getItem("_pendingToken");
      if (pendingToken) {
        sessionStorage.removeItem("_pendingToken");
        params.token = pendingToken;
        return params;
      }

      // 2. Paramètres du search (avant #)
      if (window.location.search) {
        params = Object.assign(params, transformToAssocArray(window.location.search.substr(1)));
      }

      // 3. Paramètres dans le hash après ? (ex: #!/login?token=xxx)
      var hash = window.location.hash;
      if (hash && hash.indexOf("?") !== -1) {
        var query = hash.split("?")[1];
        params = Object.assign(params, transformToAssocArray(query));
      }

      return params;
    }

    var params = getAllParams();

    if (params.token) {
      ApiService.setToken(params.token);
      $rootScope._cookieReady = ApiService.setCookieFromToken(params.token).catch(function (error) {
        console.error("Token cookie exchange failed", error);
      });
      $location.path("/home");
    }

    $rootScope.$on("$locationChangeStart", function (event, next, current) {
      // handle route changes

      log("change route", $location.url());

      if ($location.url() != "/login") {
        localStorage.setItem("$location.url", $location.url());
      }

      if ($rootScope.$user && $rootScope.$user._id) {
        ActionHistoriesService.create({
          customerId: $rootScope.$user.customerId,
          userId: "$" + $rootScope.$user._id,
          action: $location.url(),
          date: new Date()
        });
      }
    });

    setTimeout(function () {
      $("#loading").remove();
    }, 1500);
  });
})();